var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    fill: "#1D4999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m440.749 118.535-108.283-108.282c-6.611-6.612-15.4-10.253-24.75-10.253h-211.716c-19.299 0-35 15.701-35 35v442c0 19.299 15.701 35 35 35h320c19.299 0 35-15.701 35-35v-333.716c0-9.347-3.64-18.136-10.251-24.749zm-40.962 1.465h-63.787c-2.757 0-5-2.243-5-5v-63.786zm16.213 362h-320c-2.757 0-5-2.243-5-5v-442c0-2.757 2.243-5 5-5h205v85c0 19.299 15.701 35 35 35h85v327c0 2.757-2.243 5-5 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m272.1 229h95.571c8.284 0 15-6.716 15-15s-6.716-15-15-15h-95.571c-8.284 0-15 6.716-15 15s6.715 15 15 15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m272.1 329h95.571c8.284 0 15-6.716 15-15s-6.716-15-15-15h-95.571c-8.284 0-15 6.716-15 15s6.715 15 15 15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m368.1 399h-96c-8.284 0-15 6.716-15 15s6.716 15 15 15h96c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m197.256 173.157-34.592 34.591-8.157-8.157c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l18.764 18.764c2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.464 10.606-4.394l45.198-45.198c5.858-5.858 5.858-15.355 0-21.213-5.857-5.858-15.355-5.858-21.212 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m197.256 280.794-34.592 34.592-8.157-8.157c-5.857-5.857-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l18.764 18.763c2.929 2.929 6.768 4.393 10.606 4.393s7.678-1.464 10.606-4.394l45.198-45.198c5.858-5.858 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.212.001z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m197.256 380.794-34.592 34.592-8.157-8.157c-5.857-5.857-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l18.764 18.763c2.929 2.929 6.768 4.393 10.606 4.393s7.678-1.464 10.606-4.394l45.198-45.198c5.858-5.858 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.212.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.20d7d0aa76b3ff0b69e5bbd938023883.svg";
export { ForwardRef as ReactComponent };